/* eslint-disable react/jsx-key */
import React from 'react';
import { Collapse, CollapseProps, List, ListProps } from '@material-ui/core';

export type L3NavNestedMenuProps = ListProps & {
  CollapseProps: CollapseProps;
};

const L3NavNestedMenu = ({ CollapseProps, children, ...props }: L3NavNestedMenuProps): JSX.Element => {
  return (
    <List {...props} disablePadding={true} component="nav" role="nestedNav">
      <Collapse {...CollapseProps} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </List>
  );
};

export default L3NavNestedMenu;
